export default __webpack_public_path__ + "static/media/play-icon.0e5dbe83.svg";